module.exports = __webpack_public_path__ + "static/restricoes-ccabb6db60a0c2a229f4cdd3d9650942.png";